import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { element } from "prop-types";
import CardBox from "../CardBox";
import BasicCard from "../basicCards/BasicCard";

import IntlMessages from "util/IntlMessages";

const BusinessList = ({ businesses, handleBusinessChange, bookNowClicked, match, location }) => (
  // <div className="row">
  <div className="row justify-content-center features"

  >

    {businesses.map((element, index) => {
      const locationId = element.business_locations[0] ? element.business_locations[0]._id : "";

      const image = element.logo ? element.logo.url : "";
      if (!element.is_disabled) {
        return (
          // <div
          //   onClick={() => handleBusinessChange(element.business_slug)}
          //   className="col-md-4 col-sm-6"
          //   key={index}
          // >

          <BasicCard
            key={index}
            title={element.name}
            btnText="Book Now"
            image={image}
            description={element.description}
            match={matchMedia}
            bookNowClicked={bookNowClicked}
            locationId={locationId}
            businessId={element._id}
            business_slug={element.business_slug}
          />
        );
      } else {
        null
      }
    })}
    {businesses.length <1 ? <div>There Are No Salons Available</div>:null}
  </div>
);

export default withRouter(BusinessList);



// WEBPACK FOOTER //
// ./components/BusinessList/index.js